import {
    blueBlackShade,
    blueishWhiteColor,
    blueWhiteShade,
    slightBluishTintColor,
    systemColor,
    white,
    whiteStrongShadeColor,
    slightBlueishWhite,
    darkBlueShade,
    whiteShadeColor,
    lightGreenShade,
    strongGreenColor,
    lightYellowShade,
    strongOrangeColor,
    lightRedShade,
    darkRed,
} from "../../../config/ColorObj";

export const styles = {

    // ── Search ─────────────────────────────────────────────────────────────────
    searchBox: {
        marginBottom: "6px",
        marginTop: "-30px",
        marginLeft: "5px",
    },
    searchWrap: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
    },
    searchIcon: {
        position: "absolute",
        left: "10px",
        opacity: 0.4,
        pointerEvents: "none",
    },
    input: {
        padding: "8px 12px 8px 32px",
        borderRadius: "8px",
        border: "1px solid #d1d5db",
        outline: "none",
        fontSize: "13px",
        width: "210px",
        color: blueBlackShade,
        background: white,
    },

    // ── Table Container ────────────────────────────────────────────────────────
    containerCenter: {
        display: "flex",
        justifyContent: "center",
        marginTop: "6px",
    },

    tableWrapper: {
        background: white,
        borderRadius: "10px",
        border: "1px solid #e0e0e0",
        width: "100%",
        maxHeight: "570px",
        overflow: "auto",
    },

    table: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        fontSize: "14px",
        minWidth: "820px",
    },

    thead: {
        background: blueishWhiteColor,
        position: "sticky",
        top: 0,
        zIndex: 4,
    },

    th: {
        padding: "14px 16px",
        fontSize: "12px",
        fontWeight: "600",
        color: white,
        textTransform: "uppercase",
        borderBottom: "2px solid #e5e7eb",
        background: systemColor,
    },
    // thead: {
    //     background: blueishWhiteColor,
    //     position: "sticky",
    //     top: 0,
    //     zIndex: 4,
    // },
    // th: {
    //     padding: "10px 14px",
    //     fontSize: "11px",
    //     fontWeight: "500",
    //     color: slightBluishTintColor,
    //     textTransform: "uppercase",
    //     letterSpacing: "0.05em",
    //     borderBottom: "1px solid #e5e7eb",
    //     background: blueishWhiteColor,
    //     whiteSpace: "nowrap",
    //     textAlign: "left",
    // },

    // ── Main Row ───────────────────────────────────────────────────────────────
    mainRow: {
        cursor: "pointer",
    },
    td: {
        padding: "11px 14px",
        borderBottom: "1px solid #f1f5f9",
        color: blueWhiteShade,
        background: white,
        fontSize: "13px",
        verticalAlign: "middle",
        transition: "background 0.12s",
    },
    mutedText: {
        color: slightBluishTintColor,
    },

    // ── Sales Person Cell ──────────────────────────────────────────────────────
    nameCell: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    avatar: {
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        background: slightBlueishWhite,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "11px",
        fontWeight: "500",
        color: darkBlueShade,
        flexShrink: 0,
    },
    salesName: {
        fontWeight: "500",
        fontSize: "13px",
        color: blueBlackShade,
    },

    // ── Performance Pill ───────────────────────────────────────────────────────
    perfPill: {
        fontSize: "10px",
        padding: "2px 8px",
        borderRadius: "12px",
        fontWeight: "500",
        whiteSpace: "nowrap",
        display: "inline-block",
    },
    perfPillVariants: {
        hi: { background: lightGreenShade, color: strongGreenColor },
        mid: { background: lightYellowShade, color: strongOrangeColor },
        lo: { background: lightRedShade, color: darkRed },
    },

    // ── Chevron Button ─────────────────────────────────────────────────────────
    chevronBtn: {
        width: "26px",
        height: "26px",
        borderRadius: "20px",
        border: "1px solid #e5e7eb",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        color: slightBluishTintColor,
        transition: "background 0.15s",
        outline: "none",
    },
    chevronSvg: {
        transition: "transform 0.25s ease",
        display: "block",
    },

    // ── Expand Panel ───────────────────────────────────────────────────────────
    expandPanel: {
        overflow: "hidden",
        transition: "max-height 0.35s ease, opacity 0.3s ease",
    },
    expandBody: {
        background: whiteShadeColor,
        borderBottom: "1px solid #e5e7eb",
    },
    subHeader: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 16px 8px 16px",
        borderBottom: "1px solid #e5e7eb",
    },
    subHeaderLabel: {
        fontSize: "11px",
        fontWeight: "500",
        color: slightBluishTintColor,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
    },

    // ── Sub Table ──────────────────────────────────────────────────────────────
    subTableWrap: {
        overflowX: "auto",
        paddingLeft: "48px",
    },
    subTable: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "12px",
    },
    subTh: {
        textAlign: "left",
        fontSize: "10px",
        fontWeight: "500",
        color: slightBluishTintColor,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        padding: "7px 14px",
        borderBottom: "1px solid #e5e7eb",
        background: "transparent",
        whiteSpace: "nowrap",
    },
    subRow: {
        cursor: "pointer",
        transition: "background 0.12s",
    },
    subTd: {
        padding: "9px 14px",
        borderBottom: "1px solid #f1f5f9",
        color: blueWhiteShade,
        fontSize: "12px",
        verticalAlign: "middle",
        background: "transparent",
        transition: "background 0.12s",
    },

    // ── Challan Link ───────────────────────────────────────────────────────────
    challanLink: {
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        fontWeight: "500",
        color: blueBlackShade,
        fontSize: "12px",
        transition: "color 0.12s",
        cursor: "pointer",
    },
    externalIcon: {
        flexShrink: 0,
        transition: "opacity 0.15s",
    },

    // ── Status Dot ─────────────────────────────────────────────────────────────
    statusDot: {
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        flexShrink: 0,
        display: "inline-block",
        marginRight: "4px",
        verticalAlign: "middle",
    },

    // ── Progress Bar ───────────────────────────────────────────────────────────
    progWrap: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        minWidth: "110px",
    },
    progTrack: {
        flex: 1,
        height: "4px",
        background: whiteStrongShadeColor,
        borderRadius: "999px",
        overflow: "hidden",
    },
    progFill: {
        height: "100%",
        borderRadius: "999px",
        transition: "width 0.4s ease",
    },
    progPct: {
        fontSize: "11px",
        fontWeight: "500",
        minWidth: "28px",
        textAlign: "right",
        fontVariantNumeric: "tabular-nums",
    },

    // ── Empty / No-data ────────────────────────────────────────────────────────
    emptyCell: {
        textAlign: "center",
        padding: "2rem",
        color: slightBluishTintColor,
        fontSize: "13px",
    },
    noData: {
        fontSize: "12px",
        color: slightBluishTintColor,
        padding: "12px 16px",
    },
};